import Image from 'next/image'
import { useSession } from 'next-auth/react'

import { useEffect, useState } from 'react'

import axios from 'axios'

import styles from './styles.module.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark, faEye, faShare, faXmark } from '@fortawesome/free-solid-svg-icons'

import { motion } from 'framer-motion'

import { PuffLoader, PulseLoader } from 'react-spinners'

import errorMsg from '../../../Functions/errorMsg'

import JobListing from '../JobListing/JobListing';
import successMsg from '../../../Functions/successMsg'

export default function SavedJobs({ setPendingRequest }) {

  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [savedListings, setSavedListings] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(savedListings !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getSavedJobs() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/jobs/dashboard/getSavedJobs`, {
          requestingUserID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        })

        if(result && result.status === 200) {
          const data = result.data;
          setSavedListings(data);

        }

        setPendingRequest(false);
    }

    getSavedJobs();

  }, [session, status, initialLoading, savedListings])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(savedListings === null) return true;
    return false;
  }

  function refreshListings() {
    setSavedListings(null);
    setInitialLoading(null);
  }

  function handleWatch(type, listingID, username) {
    if(type === 'remove') {
      const listingPos = savedListings.findIndex((listing) => listing._id === listingID);
      if(listingPos > -1) {
        const updateSaveList = [...savedListings];
        updateSaveList[listingPos].saves.filter((user) => user !== username);
        setSavedListings(updateSaveList);

      } else {
        errorMsg("Oops! We could not remove this listing, try refreshing the page.");
      }
    }
    if(type === 'add') {
      const listingPos = savedListings.findIndex((listing) => listing._id === listingID);
      if(listingPos > -1) {
        const updateSaveList = [...savedListings];
        updateSaveList[listingPos].saves.push(username);
        setSavedListings(updateSaveList);

      } else {
        errorMsg("Oops! We could not remove this listing, try refreshing the page.");
      }
    }
  }

  const [viewListingData, setViewListingData] = useState(null);

  return (
    <section id={styles.wrapper}>
      { viewListingData !== null && <JobListing listingID={viewListingData} closeListing={() => setViewListingData(null)}  /> }

      { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }

      { isLoading() === false && (savedListings.length === 0 ?
        <div id={styles.noListings}>
          <h1>You have no saved jobs</h1>
        </div>
        :
        <section id={styles.container}>
          {
            savedListings.map((listing, index) => {
              return <ListingCard key={index} listing={listing} setViewListingData={setViewListingData} handleWatch={handleWatch} />
            })
          }
        </section>
      )}

  </section>
  )
}

const ListingCard = ({ listing, setViewListingData, handleWatch }) => {

  const { data: session, status  } = useSession();
  const username = session?.user?.token?.username;

  const listingID = listing._id;

  const [watching, setWatching] = useState(listing.saves.includes(username));
  const [watchPending, setWatchPending] = useState(false);

  const employerLogo = listing.businessLogo;
  const employerName = listing.businessTitle;

  const positionTitle = listing.positionTitle;
  const positionType = listing.positionType;

  const totalApplicants = listing.applicants.length;

  const rateData = listing.rate;

  const formatCurrency = (rate) => {
    let parsedRate = parseFloat(rate).toFixed(2);
    if (parsedRate.endsWith('.00')) {
      parsedRate = parsedRate.slice(0, -3);
    }
    parsedRate = parsedRate.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
    return parsedRate;
  };
  
  const returnPayRate = () => {
    if (rateData.type === 'Hourly') {
      return `$${formatCurrency(rateData.rate)} / hr`;
    } else if (rateData.type === 'Salary') {
      return `$${formatCurrency(rateData.rate)} / yr`;
    }
  };

  const { displayString } = createdTimeStamp(listing.creationDate);

  async function apiHandleSaved() {
    if(watchPending === true) return;
    setWatchPending(true);
    
    const type = watching === true ? 'remove' : 'add';

    if(type === "remove") {
      const result = await axios.post(`${window.location.origin}/api/jobs/helpers/unsave`, {
        listingID: listingID,
        username: username,
      }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString());
        setWatchPending(false)
      })
  
      if(result && result.status === 200) {
        setWatchPending(false)
        handleWatch('remove', listingID, username);
        successMsg("Listing unsaved.");
        setWatching(false);
      }
    }

    if(type === "add") {
      const result = await axios.post(`${window.location.origin}/api/jobs/helpers/save`, {
        listingID: listingID,
        username: username,
      }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString());
        setWatchPending(false)
      })
  
      if(result && result.status === 200) {
        setWatchPending(false)
        handleWatch('add', listingID, username);
        successMsg("Listing unsaved.");
        setWatching(true);
      }
    }


  }
  
  return (
    <div className={styles.card}>

      <section>
        <div><Image sizes='auto auto' fill objectFit='cover' src={employerLogo} alt={employerLogo} /></div>
        <div>
          <h1>{returnPayRate()}</h1>
        </div>
      </section>

      <section>
        <h1>{positionTitle}</h1>
        <h2>{positionType}</h2>
        <h3>{employerName} • {displayString}</h3>
      </section>

      <section>
        <motion.button onClick={() => setViewListingData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button>

        <motion.button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/?popup=sharedPost&_id=${listing._id}`); successMsg("Link Copied") } }><FontAwesomeIcon icon={faShare} id={styles.icon} /></motion.button>

        <motion.button onClick={() => apiHandleSaved()}>
          { watchPending === false && <>
            <FontAwesomeIcon style={{marginRight: watching === true ? '8px' : '0px'}} icon={faBookmark} id={styles.icon} />
            { watching === true && <FontAwesomeIcon icon={faXmark} id={styles.icon2} /> }
          </> }
          { watchPending === true && <PuffLoader size={25} color='black' /> }
        </motion.button>
      </section>

    </div>
  )
}

function createdTimeStamp(creationDate) {
  const units = [
      { label: 'month', ms: 30 * 24 * 60 * 60 * 1000 },
      { label: 'week', ms: 7 * 24 * 60 * 60 * 1000 },
      { label: 'day', ms: 24 * 60 * 60 * 1000 },
      { label: 'hour', ms: 60 * 60 * 1000 },
      { label: 'minute', ms: 60 * 1000 },
      { label: 'second', ms: 1000 }
  ];

  const now = new Date().getTime();
  const delta = now - new Date(creationDate).getTime();
  let result = { displayString: "just now", justPosted: delta < units[2].ms };

  for (let { label, ms } of units) {
      const value = Math.floor(delta / ms);
      if (value >= 1) {
          result.displayString = `${value} ${label}${value > 1 ? 's' : ''} ago`;
          break;
      }
  }

  return result;
}